import { apiClient } from './client'
import type { LoginResponse } from './auth'

export const googleAuthApi = {
  loginWithIdToken: (idToken: string) =>
    apiClient.post<LoginResponse>('/auth/google', { idToken }).then((r) => r.data),
}

/**
 * Carga el script Google Identity Services (GIS) si no está ya cargado.
 * Devuelve una Promise que resuelve cuando window.google.accounts.id está disponible.
 */
let gisLoadPromise: Promise<void> | null = null

export function loadGoogleIdentityServices(): Promise<void> {
  if (gisLoadPromise) return gisLoadPromise

  gisLoadPromise = new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && (window as unknown as { google?: unknown }).google) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('No se pudo cargar Google Identity Services'))
    document.head.appendChild(script)
  })

  return gisLoadPromise
}

export interface GoogleCredentialResponse {
  credential: string  // idToken JWT
  select_by?: string
}

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: {
            client_id: string
            callback: (response: GoogleCredentialResponse) => void
            auto_select?: boolean
            cancel_on_tap_outside?: boolean
          }) => void
          renderButton: (
            parent: HTMLElement,
            options: {
              type?: 'standard' | 'icon'
              theme?: 'outline' | 'filled_blue' | 'filled_black'
              size?: 'large' | 'medium' | 'small'
              text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin'
              shape?: 'rectangular' | 'pill' | 'circle' | 'square'
              width?: number | string
              locale?: string
            },
          ) => void
          prompt: () => void
        }
      }
    }
  }
}
